import { BulkActionsBarOutlet, BulkActionsBarProvider } from '@calendly/ui/components/bulk-actions-bar';
import { PageHeaderContext, PageHeaderOutlet } from '@calendly/ui/components/page-header';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { useGetUserQuery } from 'common';
import { JoinAnOrgBanner } from 'components/home_bar';
import { CenterPanelSizeProvider } from 'features/app_shell';
import { Header } from 'features/header';
import { MainContainer, MainRegion, useIsHeaderBorderBottom } from 'features/layout/main_region';
import { StickyFooterContext, StickyFooterOutlet } from 'features/layout/sticky_footer/sticky_footer';
import { LeftNavigation, LeftNavigationContext } from 'features/left_navigation';
import { MfeShareableOutlet } from 'features/mfe_shareable';
import { OrgConsolidationGlobalNotification } from 'features/organization_consolidation';
import { RightRailOutlet } from 'features/right_rail';
import { SeatRequestsBanner } from 'features/seat_requests';
import { SidebarPlaceholder } from 'features/sidebar_placeholder';
const contentContainerCss = "c5lnar5";
const contentScrollCss = "c15j6k6x";
const ContentWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    children,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentContainerCss, props.className)}>
      <div className={contentScrollCss}>
        {children}
      </div>
    </Component>;
});

/**
 * Reads the headerBorderBottom layout signal set by pages that have no page header.
 * Without a page header the global header has no visual separator below it, so we
 * render a bottom border here as a substitute. See `useHeaderBorderBottom`.
 */
const LayoutHeader = ({
  isPretending
}) => {
  const [showBorderBottom] = useIsHeaderBorderBottom();
  return <Header isPretending={isPretending} showBorderBottom={showBorderBottom} />;
};

/** Pre–product-refresh shell: same flex structure as `SideNavLayout` on `main`. */
export const LegacyAppLayout = ({
  children,
  noSidebar
}) => {
  const {
    data: {
      is_pretending: isPretending
    }
  } = useGetUserQuery();
  const isPhone = useDeviceType('isPhone');
  const pageHeaderOffsetTop = useMemo(() => {
    let offset = 0;
    if (isPretending) offset += 48;
    if (isPhone) offset += 72;
    return offset;
  }, [isPretending, isPhone]);
  if (noSidebar) return children;
  return <PageHeaderContext offsetTop={pageHeaderOffsetTop}>
      <BulkActionsBarProvider>
        <StickyFooterContext>
          <LeftNavigationContext>
            <MainContainer>
              <LeftNavigation />
              <CenterPanelSizeProvider>
                {sizeRef => <ContentWrapper ref={sizeRef} data-component="main">
                    <LayoutHeader isPretending={isPretending} />
                    <SeatRequestsBanner />
                    <PageHeaderOutlet />
                    <MainRegion>
                      <OrgConsolidationGlobalNotification />
                      <JoinAnOrgBanner />
                      {children}
                    </MainRegion>
                    <StickyFooterOutlet />
                    <BulkActionsBarOutlet />
                  </ContentWrapper>}
              </CenterPanelSizeProvider>
              <MfeShareableOutlet />
              <RightRailOutlet />
              <SidebarPlaceholder />
            </MainContainer>
          </LeftNavigationContext>
        </StickyFooterContext>
      </BulkActionsBarProvider>
    </PageHeaderContext>;
};

require("./legacy_app_layout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./legacy_app_layout.js");